import { useCallback, useState } from 'react';

function readFlag(key: string, fallback: boolean): boolean {
  try {
    const stored = localStorage.getItem(key);
    return stored === null ? fallback : stored === 'true';
  } catch {
    // Storage can be unavailable, as in private windows.
    return fallback;
  }
}

/** An on-or-off setting, remembered in this browser. */
export function useStoredFlag(key: string, fallback = false): [boolean, (on: boolean) => void] {
  const [on, setOn] = useState(() => readFlag(key, fallback));

  const update = useCallback(
    (next: boolean) => {
      setOn(next);
      try {
        localStorage.setItem(key, String(next));
      } catch {
        // Remembering is a convenience; the setting still applies to this session.
      }
    },
    [key],
  );

  return [on, update];
}
